import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw = {
  path: '/notice',
  name: 'Notice',
  redirect: '/notice/user-notice',
  component: Layout,
  meta: {
    title: '公告'
  },
  children: [
    {
      path: 'add',
      name: 'NoticeAdd',
      component: () => import('@/views/Notice/Edit/index.vue'),
      meta: {
        title: '新增公告',
        hideInMenu: true,
        hideInTab: true,
        parentMenu: '/setting/notice-config'
      }
    },
    {
      path: 'edit',
      name: 'NoticeEdit',
      component: () => import('@/views/Notice/Edit/index.vue'),
      meta: {
        title: '编辑公告',
        hideInMenu: true,
        hideInTab: true,
        parentMenu: '/setting/notice-config'
      }
    },
    {
      path: 'user-notice',
      name: 'UserNotice',
      component: () => import('@/views/Notice/User/index.vue'),
      meta: {
        title: '公告',
        hideInMenu: true,
        hideInTab: true
      }
    },
    {
      path: 'view',
      name: 'NoticeView',
      component: () => import('@/views/Notice/View/index.vue'),
      meta: {
        title: '查看公告',
        hideInMenu: true,
        hideInTab: true,
        onlyBack: true
      }
    },
    {
      path: 'preview',
      name: 'NoticePreview',
      component: () => import('@/views/Notice/View/index.vue'),
      meta: {
        title: '预览公告',
        hideInMenu: true,
        hideInTab: true,
        parentMenu: '/setting/notice-config'
      }
    }
  ]
}

export default routes
